export default __webpack_public_path__ + "static/media/canvasAndFramedA2Wood.cc7075d2.jpg";